import { registerClass } from '@food/css-manager';
export var logoImg = registerClass(function () { return "\n\tmax-width: 100%;\n\tmargin: auto;\n\twidth: 100%;\n"; });
export var footer = registerClass(function (theme, sc) { return "\n\tdisplay: flex;\n\tjustify-content: space-between;\n\tpadding: 0;\n\tmargin-top: " + theme.ratios.l * theme.font.baseSize + "px;\n\n\t&." + sc('centered') + " {\n\t\tjustify-content: center;\n\t}\n"; });
export var defaultMarginBottom = registerClass(function (theme) {
    return "margin-bottom: " + theme.ratios.l * theme.font.baseSize + "px";
});
//# sourceMappingURL=theme.js.map